// @ts-nocheck
import { populate } from 'populate';
import type { Container, NineSlicePlane, Sprite, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: ''
    },
    {
      id: 'fb5acb2e-b829-401a-b42a-37ac33830a65',
      type: 'NineSlicePlane',
      name: 'beigeBackground',
      className: '',
      x: -318,
      y: -203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 636,
      height: 406,
      leftWidth: 48,
      topHeight: 68,
      rightWidth: 48,
      bottomHeight: 48,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Darker_Field_With_Text_Field_9Slice_48x68x48x48',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          visible: false
        },
        goalsAd: {
          visible: false
        }
      }
    },
    {
      id: '81e3a838-e1ed-427d-9d23-37621379b18b',
      type: 'NineSlicePlane',
      name: 'beigeBackgroundSmall',
      className: '',
      x: -318,
      y: -203,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 636,
      height: 326,
      leftWidth: 48,
      topHeight: 68,
      rightWidth: 48,
      bottomHeight: 48,
      angle: 0,
      alpha: 1,
      visible: false,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'PopUp_Darker_Field_With_Text_Field_9Slice_48x68x48x48',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          visible: true
        },
        goalsAd: {
          visible: true
        }
      }
    },
    {
      id: 'a2fe623a-c455-4152-a948-52f261271996',
      type: 'Sprite',
      name: 'rays',
      className: 'rotate_SPL',
      x: 0,
      y: 28,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1.2,
        y: 1.2
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'New_Rays',
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      data: {
        rotationCycle: 40000
      },
      stateByName: {
        watchAd: {
          y: -17
        },
        goals: {
          visible: false
        },
        goalsAd: {
          visible: false
        }
      }
    },
    {
      id: 'b13d4892-45f5-478b-9ed6-a15559bc928b',
      type: 'Text',
      name: 'textDescription',
      className: '',
      x: 0,
      y: -164,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'You will lose a life!',
      localize: true,
      maxWidth: 600,
      maxHeight: 80,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#8f2c2b',
        stroke: 'black',
        strokeThickness: 0,
        align: 'center',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          y: -164
        },
        goals: {
          y: -164,
          text: 'You\'ll lose progress'
        },
        goalsAd: {
          text: 'You\'ll lose progress',
          y: -164
        }
      }
    },
    {
      id: 'b7b013af-2366-437a-9075-a07a38b04852',
      type: 'Container',
      name: 'scaleContainer',
      className: '',
      x: 0,
      y: 64,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'fab7a3bd-cd80-4d5e-aef0-365def3347a4',
      stateByName: {
        watchAd: {
          scale: {
            x: 0.8,
            y: 0.8
          },
          y: 17
        }
      }
    },
    {
      id: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e',
      type: 'Container',
      name: 'heartContainer',
      className: '',
      x: 0,
      y: -28,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b7b013af-2366-437a-9075-a07a38b04852',
      stateByName: {
        goals: {
          visible: false
        },
        goalsAd: {
          visible: false
        }
      }
    },
    {
      id: '3945e0ad-c067-43bc-837b-c632ee7aaf8a',
      type: 'Container',
      name: 'goalsSlot',
      className: '',
      x: 0,
      y: -20,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 0,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'b7b013af-2366-437a-9075-a07a38b04852',
      stateByName: {
        goals: {
          alpha: 1,
          y: -33
        },
        goalsAd: {
          alpha: 1,
          y: -75
        },
        watchAd: {
          y: -41
        }
      }
    },
    {
      id: '3fdeadf2-37c6-46cc-90dd-678063b51ebb',
      type: 'Sprite',
      name: 'heartShadow',
      className: '',
      x: 0,
      y: 8,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 14332799,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New_White',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: 'd637888c-7603-4587-ad88-9a9a37ce08bc',
      type: 'Sprite',
      name: 'heart',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: '9e141557-72d3-49c8-88fe-b9c7930f5a7a',
      type: 'Sprite',
      name: 'heartWhite',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Heart_Big_New_White',
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    },
    {
      id: 'bdf84706-e1bc-431c-938c-af167ce81b31',
      type: 'Text',
      name: 'minusOne',
      className: '',
      x: -15,
      y: -13,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '-1',
      localize: false,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 122,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#730027',
        strokeThickness: 10,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 5,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '8d62f165-90b3-4e12-b7f6-0ed6186d7f4e'
    }
  ],
  x: 0,
  y: 0,
  width: 664,
  height: 667,
  version: '1.0.0',
  stateNames: [
    'watchAd',
    'goals',
    'goalsAd'
  ],
  animations: [
    {
      id: '8a6c929b-7bfc-4a7c-aaa4-8c1047b781a0',
      name: 'Idle',
      playingSpeed: 1,
      totalDuration: 4000,
      blocks: [
        {
          id: '43202ada-34ea-4cbf-a865-f342802a53ca',
          type: 'Setter',
          name: 'whiteAlpha',
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 0,
          sourceName: 'heartWhite',
          disabled: false
        },
        {
          id: '0413a764-e1b1-403a-b9ff-2d2bee35874a',
          type: 'Tween',
          name: 'heartScale',
          duration: 500,
          track: 2,
          target: {
            scale: {
              x: 1.04,
              y: 1.02
            }
          },
          startAt: 0,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b4f679b9-3272-4d29-a20a-7ef0d16a25d7',
          type: 'Tween',
          name: 'whiteAlpha_1',
          duration: 490,
          track: 4,
          target: {
            alpha: 0.2
          },
          startAt: 10,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'ce8df3cb-05f5-4afb-8e4c-04aad0ba4bfb',
          type: 'Tween',
          name: 'whiteAlpha_1_copy',
          duration: 500,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 500,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'abc9fb63-4af3-471b-8ef4-907df511b55d',
          type: 'Tween',
          name: 'heartScale_1',
          duration: 500,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 500,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '18435269-e2cc-4203-93b0-4520453ea9c1',
          type: 'Tween',
          name: 'whiteAlpha_1_copy_1',
          duration: 500,
          track: 4,
          target: {
            alpha: 0.2
          },
          startAt: 1000,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '20d3114b-d563-47cd-89ba-106564356048',
          type: 'Tween',
          name: 'heartScale_copy',
          duration: 500,
          track: 2,
          target: {
            scale: {
              x: 1.04,
              y: 1.02
            }
          },
          startAt: 1000,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: 'b6391ebb-7d45-443a-848f-884546090401',
          type: 'Tween',
          name: 'whiteAlpha_1_copy_copy',
          duration: 500,
          track: 4,
          target: {
            alpha: 0
          },
          startAt: 1500,
          sourceName: 'heartWhite',
          easing: 'QuadraticInOut',
          disabled: false
        },
        {
          id: '65d85fd1-884d-44d0-9cf4-0bdef1830b8d',
          type: 'Tween',
          name: 'heartScale_1_copy',
          duration: 500,
          track: 2,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 1500,
          sourceName: 'heartContainer',
          easing: 'QuadraticInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class AreYouSureLayout {
  static raw = raw;
  root!: Container;
  beigeBackground!: NineSlicePlane;
  beigeBackgroundSmall!: NineSlicePlane;
  rays!: Sprite & { data: typeof raw['list'][3]['data'] };
  textDescription!: Text;
  scaleContainer!: Container;
  heartContainer!: Container;
  goalsSlot!: Container;
  heartShadow!: Sprite;
  heart!: Sprite;
  heartWhite!: Sprite;
  minusOne!: Text;
  rotate_SPL!: (Sprite & { data: typeof raw['list'][3]['data'] })[];
  StateName!: 'watchAd' | 'goals' | 'goalsAd';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle {
  Layout: {
    heartWhite: object;
    heartContainer: object;
  };

  BlockTypeByName: {
    whiteAlpha: object;
    heartScale: object;
    whiteAlpha_1: object;
    whiteAlpha_1_copy: object;
    heartScale_1: object;
    whiteAlpha_1_copy_1: object;
    heartScale_copy: object;
    whiteAlpha_1_copy_copy: object;
    heartScale_1_copy: object;
  };

  flowData = raw.animations[0];
}
